
export default {
  name: 'ImageAndText',

  props: {
    slice: {
      type: Object,
      required: true,
    },
  },
}
